import type { ParticipantTask } from '@piccolohealth/pbs-common';
import React from 'react';
import { DeleteConfirmModal } from '../../components/generic/DeleteConfirmModal';
import { createModal } from '../../components/generic/Modal';
import { useDeleteParticipantTaskMutation } from '../../graphql/hooks/useDeleteParticipantTaskMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantTask: ParticipantTask;
}

export const ParticipantTaskDeleteModal = createModal<Props>((props) => {
  const { participantTask, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const mutation = useDeleteParticipantTaskMutation();

  const onDeletePrime = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId: participantTask.participantId,
        participantTaskId: participantTask.id,
      })
      .then(() => {
        successToast('Task deleted successfully');
      })
      .catch((err) => {
        errorToast(`Error deleting task: ${err.message}`);
      });
  }, [
    mutation,
    organization.id,
    participantTask.participantId,
    participantTask.id,
    successToast,
    errorToast,
  ]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this task?'
      confirmation={{ level: 'Level2', confirm: participantTask.name }}
      isLoading={mutation.isLoading}
      onDelete={onDeletePrime}
    />
  );
});
